var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dataTip" },
    [
      _c("el-tooltip", { attrs: { content: _vm.tip, placement: "top" } }, [
        _c("p", [
          _vm._v(_vm._s(_vm.text)),
          _c("i", { staticClass: "el-icon-info" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }